import type { PropsWithChildren } from 'react';
import { createContext, useMemo } from 'react';

import type { ProductSearchCriteria } from '@jane/bloom/viewModels/productSearch';
import type {
  FilterTypeKeysWithJaneGold,
  ProductSearchFiltersViewModel,
} from '@jane/bloom/viewModels/productSearchFilters';
import { buildFilterKeysToDisplay } from '@jane/bloom/viewModels/productSearchFilters';

type BloomFilterContext = {
  availableFilters?: ProductSearchFiltersViewModel;
  displayFilterKeys: FilterTypeKeysWithJaneGold[];
  searchCriteria?: ProductSearchCriteria;
};

export const BloomFilterContext = createContext<BloomFilterContext>({
  displayFilterKeys: [],
});

export function BloomFilterProvider({
  availableFilters,
  children,
  displayFilterKeys = buildFilterKeysToDisplay(),
  searchCriteria,
}: PropsWithChildren<Partial<BloomFilterContext>>) {
  const contextValue = useMemo(
    () => ({
      availableFilters,
      displayFilterKeys,
      searchCriteria,
    }),
    [availableFilters, displayFilterKeys, searchCriteria]
  );

  return (
    <BloomFilterContext.Provider value={contextValue}>
      {children}
    </BloomFilterContext.Provider>
  );
}
